<div
    class="h-full w-full flex flex-col justify-between p-10 lg:p-14 xl:p-16 relative overflow-hidden transition-colors duration-500">
    <!-- BRAND GRADIENT BACKGROUND (Intro Specific) -->
    <div class="absolute inset-0 z-0 pointer-events-none">
        <!-- Background Image (Crisp) -->
        <img src="assets/images/background/bg.webp" alt="Clinic Intro"
            class="absolute inset-0 w-full h-full object-cover dark:opacity-40" />

        <!-- Brand Colored Horizontal Gradient (Left to Right) -->
        <div
            class="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/60 to-transparent dark:from-primary/80 dark:via-primary/30 dark:to-transparent">
        </div>
        <div class="absolute inset-0 bg-gradient-to-tr from-accent/20 via-transparent to-transparent opacity-50"></div>

        <!-- Texture Refinement -->
        <div class="absolute inset-0 opacity-[0.02] dark:opacity-[0.05] mix-blend-overlay"
            style="background-image: url('https://grainy-gradients.vercel.app/noise.svg');"></div>
    </div>

    <!-- 1. Header: Minimal & Professional -->
    <header class="z-10 flex flex-wrap items-center justify-between gap-6">
        <div class="flex items-center gap-3">
            <div class="w-1 h-8 bg-white rounded-full shadow-[0_0_15px_rgba(255,255,255,0.3)]"></div>
            <img src="assets/images/logos/logo_horizontal.png" alt="Dentium"
                class="h-8 lg:h-9 w-auto brightness-0 invert drop-shadow-md">
        </div>

        <div *ngIf="badge"
            class="px-4 py-1.5 rounded-xl bg-white/10 border border-white/20 backdrop-blur-sm shadow-sm flex items-center gap-2">
            <span class="relative flex h-1 w-1">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
                <span class="relative inline-flex rounded-full h-1 w-1 bg-accent"></span>
            </span>
            <span class="text-[9px] font-black uppercase tracking-[0.2em] text-white transition-colors">{{ badge
                }}</span>
        </div>
    </header>

    <!-- 2. Hero: Clean Cinematic Typography -->
    <div class="z-10 max-w-4xl animate-fade-in group">
        <h2
            class="text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter leading-none uppercase mb-6 text-white transition-transform group-hover:translate-x-1 duration-1000 drop-shadow-xl lg:drop-shadow-[0_4px_30px_rgba(0,0,0,0.3)]">
            {{ title }}
        </h2>
        <div class="flex flex-col gap-6 max-w-3xl">
            <div class="flex items-start gap-6 border-l-2 border-white/40 pl-6 lg:pl-8">
                <p class="text-white font-bold text-base md:text-lg lg:text-xl leading-relaxed drop-shadow-md">
                    {{ subtitle }}
                </p>
            </div>

            <!-- Link Action (Adaptive Text Type) -->
            <div class="pl-10">
                <button (click)="actionFn()"
                    class="group/btn flex items-center gap-3 text-[11px] font-black uppercase tracking-[0.3em] text-white hover:text-accent transition-colors drop-shadow-sm">
                    <span class="border-b-2 border-white/20 pb-0.5 group-hover/btn:border-accent transition-all">{{
                        actionText }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="3"
                        class="transform group-hover/btn:translate-x-2 transition-transform">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <!-- 3. Footer Area: Clean Clinic Info -->
    <div class="z-10">
        <!-- Insight Card (Minimalist Brand Gradient) -->
        <div *ngIf="tip"
            class="p-6 rounded-2xl bg-white/10 dark:bg-black/40 border border-white/10 flex items-center gap-5 hover:bg-white/20 dark:hover:bg-black/60 transition-all group/card shadow-2xl backdrop-blur-md overflow-hidden relative">

            <div
                class="w-10 h-10 rounded-xl bg-accent flex items-center justify-center shrink-0 border border-white/20 shadow-lg">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="20" height="20" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="3">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
            </div>
            <div class="flex-1">
                <p class="text-[9px] font-black uppercase tracking-[0.3em] text-accent mb-1 drop-shadow-sm">
                    Management Insight
                </p>
                <p class="text-sm lg:text-base text-white font-bold leading-tight">{{ tip }}</p>
            </div>
        </div>
    </div>
</div>